export const contentData = [
  {
    number: "01.",
    text: "Fast connection to the blockchain",
  },
  {
    number: "02.",
    text: "Secured endpoint for transactions",
  },
  {
    number: "03.",
    text: "Notification for every transaction",
  },
];
